import { useEffect, useRef, type DependencyList } from "react";

export type Unsubscribe = () => void;

export type Subscribe<TArgs extends unknown[]> = (callback: (...args: TArgs) => void) => Unsubscribe | void;

export function useSubscription<TArgs extends unknown[]>(
	subscribe: Subscribe<TArgs> | null | undefined,
	callback: (...args: TArgs) => void,
	deps: DependencyList = []
): void {
	const callbackRef = useRef(callback);

	useEffect(() => {
		callbackRef.current = callback;
	}, [callback]);

	useEffect(() => {
		if (!subscribe) return;

		const unsubscribe = subscribe((...args: TArgs) => {
			callbackRef.current(...args);
		});

		if (typeof unsubscribe === "function") {
			return unsubscribe;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [subscribe, ...deps]);
}
